import React from 'react';
import { ContentContainer, MetaData, Title, extendedLinkStylesWithTitle } from './MediaTeaserParts.styles';
import { MediaTeaserWrapper } from './MediaTeaserWrapper';
import { useMediaInformation } from './use-media-information';
import { isLivestream } from '../../../../../play-core/models/Media';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MediaTeaser = ({
  media,
  index,
  ariaLabel,
  labelOrder,
  ...rest
}) => {
  const {
    title,
    meta
  } = useMediaInformation(media);
  return /*#__PURE__*/_jsx(MediaTeaserWrapper, {
    media: media,
    index: index,
    ariaLabel: ariaLabel,
    linkStyles: extendedLinkStylesWithTitle,
    labelOrder: labelOrder,
    ...rest,
    children: /*#__PURE__*/_jsxs(ContentContainer, {
      children: [!isLivestream(media) && meta.length > 0 && /*#__PURE__*/_jsx(MetaData, {
        "aria-hidden": "true",
        children: meta
      }), /*#__PURE__*/_jsx(Title, {
        "aria-hidden": "true",
        children: title
      })]
    })
  });
};